import React, {Component, Fragment} from "react";
import './FAQ.css';
import {FormattedMessage} from "react-intl";
import begin3new from "../../../../../assets/img/begin3new.png";
import {Link} from "react-router-dom";
import UserInquiryForm from "../../../UserInquiryForm/UserInquiryForm";
import {Modal} from "react-bootstrap";
import {ITEM_COUNT_PER_PAGE, PAGE_OPEN_TYPE, RESOURCE_BASE_URL} from "../../../../../configuration";
import axios from "axios";
import FocusPageId from "../FocusPageId";
import InitialQuotationState from "../../../QuotationForm/InitialQuotationState";
import MetaTags from "react-meta-tags";

class FAQ extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            headings: []
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSearchOnChange = this.handleSearchOnChange.bind(this);
        this.focusPage = this.focusPage.bind(this);

        this.state = {
            show: false
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    handleClose = () => {

        this.setState({show: false});
    };

    focusPage = (elementId) => {
        FocusPageId.selectedId = {elementId}
    };

    handleShow = () => {
        this.setState({show: true});
    };

    handleSearchOnChange = (event) => {
        // console.log("Searching....");
        let search;
        if (event.target.value === "") {
            search = null
            // this.getAllCustomers(0, ITEM_COUNT_PER_PAGE)
        } else {
            search = event.target.value;
        }
        let resourceUrl = RESOURCE_BASE_URL + 'api/faq/searchContent/' + search;

        axios.get(resourceUrl)
            .then((res) => {
                this.setState({
                    items: res.data,

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });


    };


    render() {

        return (
            <div className="static-pages">
                <MetaTags>
                    <title>よくある質問｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="よくある質問｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="よくある質問｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">
                    <div className="frequent-header">
                        <h1 className="header-reduce">
                            <FormattedMessage id="app.faq.problems"
                                              defaultMessage="Do you have any problems?"
                                              description=""
                            />
                            {/* 何かお困りのことはありますか? */}
                        </h1>
                    </div>

                    <div className="brElement"></div>

                    {/*<div className="input-div1">*/}
                    {/*<div className="search-box">*/}
                    {/*<form className="example">*/}
                    {/*<div className="row" id="faq-input-id">*/}

                    {/*<input type="text" autoComplete="off" placeholder="お困りキーワード" name="search2" className="color-text-faq" id="search-faq-input" onChange={this.handleSearchOnChange} />*/}


                    {/*<Link to="">*/}

                    {/*<button type="submit" id="search-faq-btn" disabled={true}>*/}
                    {/*&#8981;*/}
                    {/*/!*<div className="srcBtn"> &#8981;</div>*!/*/}
                    {/*</button>*/}
                    {/*</Link>*/}

                    {/*<div className="faq-search-results">*/}
                    {/*{this.state.items!== undefined && this.state.items.map(item => {*/}
                    {/*return(*/}
                    {/*<div className="typeahead-row" onClick={()=>this.focusPage("a")}>*/}
                    {/*<Link to={"/"+item.link} className="type-link">{item.heading}*/}
                    {/*<p className="faq-search-text-trimmed">{item.trimmedText.substring(0,30)+"..."}</p>*/}
                    {/*</Link>*/}
                    {/*</div>*/}
                    {/*);*/}

                    {/*})*/}
                    {/*}*/}
                    {/*</div>*/}

                    {/*</div>*/}
                    {/*</form>*/}
                    {/*</div>*/}
                    {/*</div>*/}


                    <Fragment>
                        <div>
                            <h3  className="header-reduce">
                                <FormattedMessage id="app.faq.Search"
                                                  defaultMessage="Search by category"
                                                  description=""
                                />
                                {/*カテゴリーから探す*/}
                            </h3>
                        </div>

                        <div className="brElement"></div>


                        <div className="row button-row">
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/member"
                                   target={PAGE_OPEN_TYPE}
                                >

                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.registration"
                                                          defaultMessage="About member registration / registration information"
                                                          description=""
                                        />
                                        {/*会員登録・登録情報について*/}
                                    </button>
                                </a>
                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/order"
                                   target={PAGE_OPEN_TYPE}
                                >

                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.yourorder"
                                                          defaultMessage="About your order"
                                                          description=""
                                        />
                                        {/*ご注文について*/}
                                    </button>
                                </a>
                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/cancel"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.cancellation"
                                                          defaultMessage="About cancellation"
                                                          description=""
                                        />
                                        {/*キャンセルについて*/}
                                    </button>
                                </a>
                            </div>
                        </div>

                        <div className="row button-row">
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/gerber-file"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.upload"
                                                          defaultMessage="About data creation and upload"
                                                          description=""
                                        />
                                        {/*データ作成・アップロードについて*/}
                                    </button>
                                </a>
                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/payment"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.aboutpayment"
                                                          defaultMessage="About payment"
                                                          description=""
                                        />
                                        {/*お支払いについて*/}
                                    </button>
                                </a>
                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/product"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.specifications"
                                                          defaultMessage="About product specifications"
                                                          description=""
                                        />
                                        {/*製品仕様について*/}
                                    </button>
                                </a>
                            </div>
                        </div>

                        <div className="row button-row">
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/delivery-date"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.deliverytime"
                                                          defaultMessage="About delivery time"
                                                          description=""
                                        />
                                        {/*納期について*/}
                                    </button>
                                </a>
                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/shipment"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.shipping"
                                                          defaultMessage="About shipping"
                                                          description=""
                                        />
                                        {/*出荷について*/}
                                    </button>
                                </a>

                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/quality"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.qualityassurance"
                                                          defaultMessage="About quality assurance and returns"
                                                          description=""
                                        />
                                        {/*品質保証・返品について*/}
                                    </button>
                                </a>

                            </div>
                        </div>

                        <div className="row button-row">
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/import-tax"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.customsrequirements"
                                                          defaultMessage="About customs requirements"
                                                          description=""
                                        />
                                        {/*関税要件について*/}
                                    </button>
                                </a>

                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <Link to="/companyProfile">
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.operatingcompany"
                                                          defaultMessage="About operating company"
                                                          description=""
                                        />
                                        {/*運営会社について*/}
                                    </button>
                                </Link>

                            </div>
                            <div className="col-md-4 faq-item-btn">
                                <a href="https://kitcutlabo.blog/category/pcb-basic-faq/other"
                                   target={PAGE_OPEN_TYPE}
                                >
                                    <button className="item-button">
                                        <FormattedMessage id="app.faq.Other"
                                                          defaultMessage="Other"
                                                          description=""
                                        />
                                        {/*その他*/}
                                    </button>
                                </a>
                            </div>
                        </div>


                        <div className="text-div">
                            <FormattedMessage id="app.faq.donotsolve"
                                              defaultMessage="If you do not solve the above, please contact us"
                                              description=""
                            />
                            {/*上記で解決しなかった場合は */}
                            <span onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>
                            <text id="faq-here-link"><FormattedMessage id="app.faq.here"
                                                                       defaultMessage="here"
                                                                       description=""/></text>

                                {/*こちら*/}
                        </span>

                            <FormattedMessage id="app.faq.contactus"
                                              defaultMessage="Please contact us."
                                              description=""
                            />
                            {/*よりお問い合わせください。*/}
                        </div>
                    </Fragment>
                </div>
                <Modal dialogClassName="contact-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text-faq">
                            <FormattedMessage id="app.navigation.contact"
                                              defaultMessage="Contact"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form-text">
                            {/*<UserInquiryForm userId={this.props.location.state.userId} handle={this.handleClose}/>*/}
                            {/*<UserInquiryForm userId={this.props.location.userId} handle={this.handleClose}/>*/}


                            {InitialQuotationState.loggedUserId !== null ?
                                <UserInquiryForm userId={InitialQuotationState.loggedUserId} handle={this.handleClose}/>
                                :
                                <UserInquiryForm userId={null} handle={this.handleClose}/>

                            }

                            {/*<UserInquiryForm userId={InitialQuotationState.loggedUserId} handle={this.handleClose}/>*/}
                        </div>

                    </Modal.Body>

                </Modal>
            </div>
        );
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FAQ.js